export class BaseModel {
    public static createInstance<TModel extends object>(
        instance: new () => TModel,
        data: Partial<TModel> = {} as TModel,
    ): TModel {
        return Object.assign(new instance(), data);
    }
}
